import { Box, Grid, Typography } from "@mui/material";

export default function ChaosToClarity({ lessThanXL }) {

  return (
    <section>
      <Box
        mt={12}
        sx={{
          color: "#1F1F1F",
          paddingLeft: !lessThanXL ? "70px" : "21px",
          paddingRight: !lessThanXL ? "70px" : "21px",
        }}
      >
        <Typography
          fontWeight="700"
          component="span"
          sx={{
            paddingRight: "10px",
            fontSize: !lessThanXL ? "34px" : "32px",
            fontStyle: !lessThanXL ? "italic" : "",
            background: (theme) => theme.palette.gradient.toTop,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            lineHeight: "normal",
          }}
        >
          From Chaos to Clarity
        </Typography>
        <Typography
          component="span"
          lineHeight={"normal"}
          fontWeight="700"
          fontSize="34px"
          gutterBottom
        >
          - in Seconds
        </Typography>
        <Typography
          lineHeight={"normal"}
          variant="body1"
          fontSize="18px"
          fontWeight={400}
          mb={6}
          mt={3}
        >
          Upload contracts, reports, or policies. DokuSense transforms them into
          structured answers, summaries, and insights - with full privacy and
          transparency.
        </Typography>

        <Grid container spacing={4} mt={5}>
          <Grid item xs={12} md={4}>
            <Typography
              mb={3}
              sx={{
                background: (theme) => theme.palette.gradient.toTop,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
              lineHeight={"normal"}
              variant="subtitle1"
              fontSize="24px"
              fontWeight="700"
              gutterBottom
            >
              Chat with Documents
            </Typography>
            <Typography
              lineHeight={"normal"}
              variant="body2"
              fontSize="18px"
              fontWeight={400}
            >
              Interact with your documents <br />
              through natural language queries
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography
              mb={3}
              sx={{
                background: (theme) => theme.palette.gradient.toTop,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
              lineHeight={"normal"}
              variant="subtitle1"
              fontSize="24px"
              fontWeight="bold"
              gutterBottom
            >
              Smart Summarization
            </Typography>
            <Typography
              lineHeight={"normal"}
              variant="body2"
              fontSize="18px"
              fontWeight={400}
            >
              Quickly distill lengthy documents <br />
              into concise summaries
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography
              mb={3}
              sx={{
                background: (theme) => theme.palette.gradient.toTop,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
              lineHeight={"normal"}
              variant="subtitle1"
              fontSize="24px"
              fontWeight="bold"
              gutterBottom
            >
              Organizational Tools
            </Typography>
            <Typography
              lineHeight={"normal"}
              variant="body2"
              fontSize="18px"
              fontWeight={400}
            >
              Categorize and tag documents for <br />
              effortless retrieval.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </section>
  );
}
